import {
  cycleStatus,
  cyclePriority,
  statusColor,
  priorityColor,
} from "../../utils/taskHelpers";


export default function TaskMeta({

  task,
  onUpdate,

  editingAssignedId,
  assignedValue,
  setAssignedValue,

  startEditAssigned,
  saveAssignedTo,

}) {


return (

<div className="flex flex-wrap gap-2 mt-4">


<span

onClick={() =>
 onUpdate(task.id,{
  status: cycleStatus(task.status)
 })
}

className={`
px-3
py-1
rounded-full
text-xs
font-medium
cursor-pointer
hover:opacity-80
transition
${statusColor(task.status)}
`}

>

{task.status.replace("_"," ")}

</span>



<span

onClick={() =>
 onUpdate(task.id,{
  priority: cyclePriority(task.priority)
 })
}

className={`
px-3
py-1
rounded-full
text-xs
border
cursor-pointer
hover:opacity-80
transition
${priorityColor(task.priority)}
`}

>

{task.priority}

</span>




{
editingAssignedId === task.id

?

<input

autoFocus

value={assignedValue}

onChange={(e)=>
 setAssignedValue(e.target.value)
}

onBlur={() =>
 saveAssignedTo(task.id)
}

onKeyDown={(e)=>{
 if(e.key==="Enter"){
  saveAssignedTo(task.id);
 }
}}

className="
px-3
py-1
rounded-full
text-xs
bg-[#111318]
border
border-slate-700
text-slate-300
outline-none
"

/>


:

<span

onClick={() =>
 startEditAssigned(task)
}

className="
px-3
py-1
rounded-full
text-xs
bg-purple-500/20
text-purple-300
border
border-purple-500/30
cursor-pointer
hover:opacity-80
"

>

{
task.assigned_to
?
`Assigned to ${task.assigned_to}`
:
"Unassigned"
}

</span>

}


</div>

);

}